"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var SalesForceApplicationDetailsObject = /** @class */ (function () {
    function SalesForceApplicationDetailsObject() {
    }
    SalesForceApplicationDetailsObject.create = function (contractDocument, salesForceInfo) {
        var baseObject = {
            Account__c: salesForceInfo.torihikisakiId,
            Contact__c: salesForceInfo.applyTorihikisakiId,
            ApplicationConfirmationEmailSubject__c: salesForceInfo.emailSubject,
            ApplicationContentsConfirmationEmail__c: salesForceInfo.emailContent,
            SendApplicationURLGuideEmail__c: 'true'
        };
        if (value_checker_1.default.isPresent(salesForceInfo.applicationDetailId)) {
            baseObject['Id'] = salesForceInfo.applicationDetailId;
        }
        else {
            baseObject['OwnerId'] = salesForceInfo.lastUpdateUser;
        }
        return baseObject;
    };
    /**
     * 法人確認の再申し込み項目を作成する
     * @param id SalesforceのObjectID
     * @param title
     * @param body
     * @returns
     */
    SalesForceApplicationDetailsObject.createFormForRetryVerificationApplication = function (id, title, body) {
        return {
            Id: id,
            VerificationRetrySubject__c: title,
            VerificationRetryText__c: body
        };
    };
    return SalesForceApplicationDetailsObject;
}());
exports.default = SalesForceApplicationDetailsObject;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/sales_force/application_details_object.ts
// module id = KrSF
// module chunks = 1